import React from "react";

function ProductLcmAdBd() {
  return (
    <div>
      <h1 className='prodlcmadbd'>Product/LCM AD Board</h1>
    </div>
  );
}

export default ProductLcmAdBd;